import { useEffect, useState } from 'react';
import { useAppRouter } from '@/hooks/use.app.router';
import { AppModal } from '@/components/compose/app.modal';
import { AppScreen } from '@/components/compose/app.screen';
import { Box } from '@/components/base/box';
import { LoaderContainer } from '@/components/compose/loader.container';
import { ChatList } from '@/components/compose/chat/chat.list';
import styled from 'styled-components/native';
import { AppImageView } from '@/components/base/app.image.view';
import { hpVal, wpVal } from '../../utils';
import { getFileSystem } from '../../file-manager';
import { useChatHistory } from '@/apis/chat';
import { useAssets } from '@/hooks/use.assets';
import { Chat } from '@matap/shared';

export default function ChatHistoryModal() {
  const { params } = useAppRouter();
  const visitId = (params as any)?.visitId;
  if (!visitId) {
    return null;
  }
  const assets = useAssets();
  const chatHistoryApi = useChatHistory({ query: { id: visitId as string } });

  const [data, setData] = useState<Chat[]>();

  useEffect(() => {
    if (chatHistoryApi.data) {
      requestIdleCallback(() => {
        setData([...chatHistoryApi.data].reverse());
      });
    }
  }, [chatHistoryApi.data]);

  useEffect(() => {
    return () => {
      getFileSystem(true).purge();
    };
  }, []);

  return (
    <AppModal title={'تاریخچه مکالمه'}>
      <Box flex={1}>
        <LoaderContainer apis={[chatHistoryApi]}>
          <Background pointerEvents={'none'} source={assets.images.chat_bg} contentFit={'cover'} />
          {data && (
            <Box flex={1}>
              <ChatList temporary={true} data={data} />
            </Box>
          )}
        </LoaderContainer>
      </Box>
    </AppModal>
  );
}

const Background = styled(AppImageView)`
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: ${hpVal(100)};
  user-select: none;
`;
